import { StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';
function MinusIconRaw({
  style,
  fill,
}: {
  style?: StyleProp<ViewStyle>;
  fill?: string;
  className?: string;
}) {
  return (
    <Svg width="17" height="3" viewBox="0 0 17 3" fill={fill} style={style}>
      <Path
        d="M1.33594 1.65479H15.6992"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Svg>
  );
}

export const MinusIcon = nativewindWrapSvg(MinusIconRaw);
